<div *ngIf="loaded==1">

    <div fxLayoutAlign="center" class="pd40">
        <div class="contentContainer">

            <!-- header -->
            <div fxLayout="row" fxLayoutAlign="space-between center" class="fw pdb08 border-b">

                <div fxLayout="row" fxLayoutAlign=" center">
                    <img [src]="logo" alt="logoPredictiva21" class="avatarSquare3">
                    <span class="mgl10 ft500 ft20 gray-8">Predyc</span>
                </div>

                <div>
                    <h6 class="ft500 ft16 mgb0 gray-10"> Detalle Pago</h6>
                </div>

                <div fxLayout="row" class="noPrint">
                    <div *ngIf="pago.instructorEstatusPago == 'en proceso'">
                    <div *ngIf="token =='superadmin' || token == 'administrador'"
                        class="tag radius3 border mgr05 backGreen1" (click)="marcarPagado()">
                        <div fxLayout="row" fxLayoutAlign=" center" class="greenLink">
                            <span class="pdl05 greenLink ft500 ft11">Marcar Pagado</span>
                            <mat-icon class="mgl05 linkIcon ft16">add</mat-icon>
                        </div>
                    </div>
                </div>
                    <div *ngIf="token =='superadmin' || token == 'administrador'"
                        class="tag radius3 border mgr05 backRed1" (click)="onDelete()">

                        <div fxLayout="row" fxLayoutAlign=" center" class="redLink">
                            <span class="pdl05 redLink ft500 ft11">Cancelar pago</span>
                            <mat-icon class="mgl05 linkIcon ft16">delete</mat-icon>
                        </div>
                    </div>
                    <div class="tag radius3 border mgr05 backBlue1" (click)="print()">
                        <div fxLayout="row" fxLayoutAlign=" center" class="blueLink noPrint">
                            <span class="pdl05 blueLink ft500 ft11">Imprimir</span>
                            <mat-icon class="mgl05 linkIcon ft16">print</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mgt20 mgb40 ">
                <div>
                    <span class="ft14 gray-5">Fecha de pago: </span>
                    <span class="gray-8">{{pago.instructorFechaPago.toDate() | date}}</span>
                </div>
                <div>
                    <span class="ft14 gray-5">Via de pago: </span>
                    <span class="gray-8">{{pago.instructorViaPago}}</span>
                </div>

                <div>
                    <span class="ft14 gray-5">Identificador de Pago (ID): </span>
                    <span class="gray-8">{{pago.pagoId}}</span>
                </div>
                <div>
                    <span class=" ft14 gray-5">Instructor: </span>
                    <span class="gray-8">{{pago.instructorNombre}}</span>
                </div>
                <div>
                    <span class=" ft14 gray-5">Total: </span>
                    <span class="gray-8">{{pago.pagoTotal}} *</span>
                </div>
                <div>
                    <span class=" ft14 gray-5">Estatus: </span>
                    <span class="gray-8">{{pago.instructorEstatusPago}} *</span>
                </div>
            </div>

            <!-- table -->

            <div class="tableContainer">
                <table>
                    <tr>
                        <th>Estudiante</th>
                        <th>Curso</th>
                        <th class="nowrap">Transaccion ID</th>
                        <th>Fecha</th>
                        <th>Estatus</th>
                        <th>Precio</th>
                        <th>Desc.</th>
                        <th class="nowrap">P Fin.</th>
                        <th>Moneda</th>
                        <th>Instr.</th>
                        <th>Total</th>
                    </tr>
                    <tr *ngFor="let item of pago.transacciones;  let i=index">
                        <td class="centertext ft10 w-10">{{item.usuarioNombre}}</td>
                        <td class="centertext ft10 w-20">{{item.cursoTitulo}}</td>
                        <td class="centertext ft9 breakword w-20">{{item.transaccionId}}</td>
                        <td class="centertext ft10 w-10">{{item.transaccionFecha.toDate() | date }}</td>
                        <td class="centertext ft10 w-05">{{item.transaccionEstatusCobro}}</td>
                        <td class="centertext ft10 w-05">{{item.cursoPrecioOriginal}}</td>
                        <td class="centertext ft10 w-05">{{item.cursoPorcentajeDescuento}}%</td>
                        <td class="centertext ft10 w-05">{{item.cursoPrecioFinal}}</td>
                        <td class="centertext ft10 w-05">{{item.transaccionMoneda}}</td>
                        <td class="centertext ft10 w-05">{{item.instructorPorcentaje}}%</td>
                        <td class="centertext ft10 w-05">{{item.instructorTotal}}</td>
                    </tr>
                </table>
            </div>
            <div class="mgt20">
                <span class="ft12 gray-5">* El monto indicado no incluye IVA en caso de aplicar. </span>
            </div>

        </div>
    </div>
</div>